import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

// BC taxes: 5% GST on everything, plus 7% PST on drinks only.
export const GST_RATE = 0.05;
export const PST_RATE = 0.07;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('wrappus_cart') || '[]'); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('wrappus_cart', JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.id === item.id);
      if (idx >= 0) {
        const copy = [...cur];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + 1 };
        return copy;
      }
      return [...cur, { ...item, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const setQty = (id, qty) => setItems((cur) => cur.map((i) => i.id === id ? { ...i, qty: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const pstBase = items.reduce((s, i) => s + (i.pst ? Math.min(i.pstAmount ?? i.price, i.price) * i.qty : 0), 0);
  const gst = +(subtotal * GST_RATE).toFixed(2);
  const pst = +(pstBase * PST_RATE).toFixed(2);
  const tax = +(gst + pst).toFixed(2);
  const total = +(subtotal + tax).toFixed(2);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, gst, pst, tax, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}
